import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type GetCanDeleteSemesterFromStudentQueryVariables = Types.Exact<{
  matchStudentSemesterIds?: Types.Maybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
}>;


export type GetCanDeleteSemesterFromStudentQuery = { canDeleteSemesterFromStudent?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'CanDeleteSemesterFromStudent', studentId: number, semesterId: number, matchStudentSemesterId: number, canDelete: boolean }>>> };


export const GetCanDeleteSemesterFromStudentDocument = gql`
    query getCanDeleteSemesterFromStudent($matchStudentSemesterIds: [Int!]) {
  canDeleteSemesterFromStudent(matchStudentSemesterIds: $matchStudentSemesterIds) {
    studentId
    semesterId
    matchStudentSemesterId
    canDelete
  }
}
    `;

/**
 * __useGetCanDeleteSemesterFromStudentQuery__
 *
 * To run a query within a React component, call `useGetCanDeleteSemesterFromStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanDeleteSemesterFromStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanDeleteSemesterFromStudentQuery({
 *   variables: {
 *      matchStudentSemesterIds: // value for 'matchStudentSemesterIds'
 *   },
 * });
 */
export function useGetCanDeleteSemesterFromStudentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCanDeleteSemesterFromStudentQuery, GetCanDeleteSemesterFromStudentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCanDeleteSemesterFromStudentQuery, GetCanDeleteSemesterFromStudentQueryVariables>(GetCanDeleteSemesterFromStudentDocument, baseOptions);
      }
export function useGetCanDeleteSemesterFromStudentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCanDeleteSemesterFromStudentQuery, GetCanDeleteSemesterFromStudentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCanDeleteSemesterFromStudentQuery, GetCanDeleteSemesterFromStudentQueryVariables>(GetCanDeleteSemesterFromStudentDocument, baseOptions);
        }
export type GetCanDeleteSemesterFromStudentQueryHookResult = ReturnType<typeof useGetCanDeleteSemesterFromStudentQuery>;
export type GetCanDeleteSemesterFromStudentLazyQueryHookResult = ReturnType<typeof useGetCanDeleteSemesterFromStudentLazyQuery>;
export type GetCanDeleteSemesterFromStudentQueryResult = ApolloReactCommon.QueryResult<GetCanDeleteSemesterFromStudentQuery, GetCanDeleteSemesterFromStudentQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
